import { Box, Card, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router';

// @ts-expect-error FIXME some config item is missing to make this import typecehck
import LogoImage from '@/assets/images/logo_round_transparent.webp';
import { assertNever } from '@/lib/assertions';
import { clearTokenStorage } from '@/lib/auth';
import { InviteAuthState, useInviteTokenAuth } from '@/lib/hooks/useInviteTokenAuth';

import { BigSpinner } from './BigSpinner';
import { Page } from './Page';

const InvalidInvitePanel = () => {
    const { t } = useTranslation();

    return (
        <Page>
            <Card sx={{ padding: '24px', width: '500px', margin: '0 auto', pb: 4 }}>
                <Box sx={{ textAlign: 'center' }}>
                    <img
                        src={LogoImage}
                        alt={t('pages.login.logo-alt-text', 'Outgrow Your Garage logo')}
                        width="50%"
                    ></img>
                </Box>
                <Typography
                    variant="h1"
                    sx={{
                        fontSize: 50,
                        textAlign: 'center',
                        pb: 2,
                    }}
                >
                    {t('pages.invalid_invite.title', 'Invalid Invite')}
                </Typography>
                <Box
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    {t('pages.invalid_invite.error_message', 'The invite link you clicked is invalid or has expired.')}
                </Box>
            </Card>
        </Page>
    );
};

export const InviteTokenRoute = () => {
    const { token } = useParams();

    const navigate = useNavigate();
    const { authState, checkAuth } = useInviteTokenAuth(token);

    // biome-ignore lint/correctness/useExhaustiveDependencies: one time effect
    useEffect(() => {
        // If a user is clicking on an invite link, we want to log them out first
        // if they happened to be logged in as another user.
        clearTokenStorage();

        if (!token) {
            navigate('/');
        }

        if (authState === InviteAuthState.PRE_AUTH) {
            checkAuth();
        }
    }, []);

    switch (authState) {
        case InviteAuthState.PRE_AUTH:
            return <BigSpinner />;

        case InviteAuthState.NOT_AUTHENTICATED:
            return <InvalidInvitePanel />;

        case InviteAuthState.AUTHENTICATED:
            return <Outlet />;

        default:
            assertNever(authState);
    }
};
